import React from "react";
import { View } from "react-native";
import Input from "@/components/ui/Input";
import { CurrencyInput } from "@/components/ui/CurrencyInput";
import { ClientInput } from "@/components/inputs/ClientInput";
import { ProjectInput } from "@/components/inputs/ProjectInput";
import { ShiftInput } from "@/components/inputs/ShiftInput";
import { ExpenseForm } from "./types";
import { UserPicker } from "@/components/Pickers/UserPicker";
import { UserInput } from "@/components/inputs/UserInput";

interface ExpenseFieldsProps {
  expense: ExpenseForm;
  updateExpense: (patch: Partial<ExpenseForm>) => void;
}

export function ExpenseFields({ expense, updateExpense }: ExpenseFieldsProps) {
  return (
    <View style={{ gap: 16 }}>
      <Input
        testID="expense-category-input"
        placeholder="Category (optional)"
        value={expense.category || ""}
        onChangeText={(v) => updateExpense({ category: v })}
        icon="category"
      />

      <Input
        testID="expense-description-input"
        placeholder="Description (optional)"
        value={expense.description || ""}
        onChangeText={(v) => updateExpense({ description: v })}
        multiline
        numberOfLines={3}
        containerStyle={{ height: "auto", minHeight: 60, alignItems: "flex-start", paddingVertical: 8 }}
        style={{ minHeight: 44, textAlignVertical: "top" }}
      />

      <UserInput
        value={expense.user_id || null}
        label="Crew Member (optional)"
        onChange={(userId) => updateExpense({ user_id: userId ?? "" })}
      />

      <ClientInput
        value={expense.client_id || null}
        state="editing"
        label="Client *"
        onChange={(clientId) =>
          updateExpense({
            client_id: clientId || "",
            project_id: "",
            shift_id: null,
          })
        }
      />

      <ProjectInput
        value={expense.project_id || null}
        clientId={expense.client_id || null}
        state="editing"
        label="Project *"
        onChange={(projectId) =>
          updateExpense({
            project_id: projectId || "",
            shift_id: null,
          })
        }
      />

      <ShiftInput
        value={expense.shift_id || null}
        projectId={expense.project_id || null}
        state="editing"
        label="Shift"
        placeholder="Select shift (optional)"
        onChange={(shiftId) => updateExpense({ shift_id: shiftId })}
      />

      <CurrencyInput
        testID="expense-amount-input"
        label="Amount *"
        value={expense.amount || null}
        onChange={(v) => updateExpense({ amount: v ?? 0 })}
      />
    </View>
  );
}
